<template>
  <div class="frame14_body">
    <div class="frame14">
      <div class="frame14_top">
        分红与募资
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame14_close"
        />
      </div>
      <div class="frame14_content">
        <div class="frame14_content_title">股息收益率</div>
        <div class="frame14_content_text">
          【释义】：简称股息率，是每年分配给股东的股息占股价的百分比。是衡量企业是否具有投资价值的重要指标之一。
        </div>
        <div class="frame14_content_text">【算法】：股息收益率=每股股利（税前）/每股市价*100% </div>
        <div class="frame14_content_text">【单位】：%</div>
      </div>
      <div class="frame14_content">
        <div class="frame14_content_title">分红募资比</div>
        <div class="frame14_content_text">
          【释义】：历年来企业现金分红总额占历年来募集资金的百分比。说明企业是回报投资人多还是向投资人索取的更多。反映公司的发展和盈利状况。 
        </div>
        <div class="frame14_content_text">【算法】：分红募资比=总现金分红/募资总额*100%</div>
        <div class="frame14_content_text">【单位】：%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame14_close() {
      this.$emit("frame14_close");
    },
  },
};
</script>

<style scoped>
.frame14_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame14 {
  width: 448px;
  height: 450px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame14_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame14_content {
  margin-top: 28px;
}
.frame14_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame14_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame14_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>